import React from "react";
import { Form } from "react-router-dom";
import SmartButton from "../ui/buttons/SmartButton";
import { useButtonState } from "../../hooks/useButtonState";

function ForgotPasswordForm() {
  const { buttonState, handleFormSubmit, isSubmitting } = useButtonState();
  return (
    <Form
      className="auth-form"
      method="post"
      onSubmit={handleFormSubmit}
    >
      <div className="auth-form-content">
        {/* Section 1: Title */}
        <p className="auth-form-title">
          Enter your email address to receive a password reset link.
        </p>

        {/* Section 2: Form Fields */}
        <div className="auth-form-fields">
          {/* Email Field */}
          <div className="form-field">
            <div className="email-input-container">
              <input
                type="email"
                name="email"
                className="form-input"
                placeholder="Email"
                autoComplete="off"
                required
              />
              <img
                src="/images/icons/email_blue_light.svg"
                alt="Email"
                className="email-icon"
              />
            </div>
          </div>

          <SmartButton
            text="Reset Password"
            loadingText="Processing..."
            successText="Email Sent!"
            state={buttonState}
            isSubmitting={isSubmitting}
            type="submit"
          />
        </div>
      </div>
    </Form>
  );
}

export default ForgotPasswordForm;
